<template src='./project-list-management.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import ProjectListType from './types/ProjectListType.vue'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage,
    'project-list-type': ProjectListType
  },
  data () {
    return {
      projectListTypes: [
        { id: '3', text: this.$t('projects.listTypes.3') },
        { id: '4', text: this.$t('projects.listTypes.4') },
        { id: '5', text: this.$t('projects.listTypes.5') },
        { id: '6', text: this.$t('projects.listTypes.6') },
        { id: '1', text: this.$t('projects.listTypes.1') },
        { id: '2', text: this.$t('projects.listTypes.2') }
      ],
      pageLoader: false,
      tab: null,
      listType: this.$route.params.listType
    }
  },
  mounted () {
    if (this.tab !== this.listType) {
      this.tab = this.listType
    }
    EventBus.$on('projectDocumentsLoader', (loader) => {
      this.pageLoader = loader
    })
  },
  computed: {
    helpUrl () {
      return Vue.$helpConfig.projectListsList.replace('{listName}', this.tab ? Vue.$helpConfig.projectLists.filter(x => x.value === Number(this.tab))[0].text : '')
    }
  },
  methods: {
    tabChanged (tab) {
      if (this.listType !== tab.toString()) {
        this.$router.push({ name: 'projectListsType', params: { listType: tab } })
      }
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}
</style>
